
(function(){
"use strict";

var RM = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
var gsap = window.gsap;
var hasGSAP = typeof gsap !== 'undefined' && !!gsap;
var ST = window.ScrollTrigger;
var hasST = hasGSAP && typeof ST !== 'undefined' && !!ST;
var SplitText = window.SplitText;
var hasSplit = hasGSAP && typeof SplitText !== 'undefined' && !!SplitText;
if(hasGSAP){ try{ if(hasST) gsap.registerPlugin(ST); if(hasSplit) gsap.registerPlugin(SplitText); }catch(e){} }
if(RM || !hasGSAP || !hasST){ document.documentElement.className = document.documentElement.className.replace(/\bjs\b/g,''); }

var isMobile = window.matchMedia('(max-width:900px)').matches;
function $(id){ return document.getElementById(id); }

/* ---------------- Lenis ---------------- */
var lenis = null;
if(!RM && typeof window.Lenis !== 'undefined'){
  try{
    lenis = new window.Lenis({ duration:1.15, smoothWheel:true, wheelMultiplier:1, touchMultiplier:1.6 });
    if(hasST && hasGSAP){
      lenis.on('scroll', ST.update);
      gsap.ticker.add(function(t){ lenis.raf(t*1000); });
      gsap.ticker.lagSmoothing(0);
    } else {
      (function raf(t){ lenis.raf(t); requestAnimationFrame(raf); })(0);
    }
  }catch(e){ lenis = null; }
}

function scrollToId(id){
  if(!id || id === '#') return;
  var el = document.querySelector(id); if(!el) return;
  if(lenis){ lenis.scrollTo(el, { offset:-70, duration:1.2 }); }
  else { el.scrollIntoView({ behavior: RM ? 'auto' : 'smooth' }); }
}
document.querySelectorAll('a[href^="#"]').forEach(function(a){
  a.addEventListener('click', function(e){
    var href = a.getAttribute('href');
    if(href && href.length > 1){ e.preventDefault(); scrollToId(href); }
  });
});

/* ---------------- custom cursor ---------------- */
(function(){
  var dot = $('cdot'), ring = $('cring');
  if(!dot || !ring || RM || isMobile) return;
  var rx = window.innerWidth/2, ry = window.innerHeight/2, dx = rx, dy = ry;
  window.addEventListener('mousemove', function(e){
    dx = e.clientX; dy = e.clientY;
    dot.style.transform = 'translate(' + dx + 'px,' + dy + 'px) translate(-50%,-50%)';
  }, {passive:true});
  (function loop(){
    rx += (dx-rx)*0.2; ry += (dy-ry)*0.2;
    ring.style.transform = 'translate(' + rx + 'px,' + ry + 'px) translate(-50%,-50%)';
    requestAnimationFrame(loop);
  })();
  document.querySelectorAll('[data-hot],a,button,.product-card,.review,.tile').forEach(function(el){
    el.addEventListener('mouseenter', function(){ ring.classList.add('hot'); });
    el.addEventListener('mouseleave', function(){ ring.classList.remove('hot'); });
  });
})();

/* ---------------- nav state + progress ring ---------------- */
(function(){
  var nav = $('navbar'), fill = $('progFill'), pct = $('progPct');
  function upd(){
    var y = lenis ? lenis.scroll : (window.pageYOffset || document.documentElement.scrollTop);
    if(nav){ if(y > 40) nav.classList.add('scrolled'); else nav.classList.remove('scrolled'); }
    var h = document.documentElement.scrollHeight - window.innerHeight;
    var p = h > 0 ? Math.min(1, Math.max(0, y/h)) : 0;
    if(fill) fill.style.strokeDashoffset = String(100 - p*100);
    if(pct) pct.textContent = String(Math.round(p*100));
  }
  if(lenis) lenis.on('scroll', upd); else window.addEventListener('scroll', upd, {passive:true});
  window.addEventListener('resize', upd);
  upd();
})();

/* ---------------- announcement rotator ---------------- */
(function(){
  var rot = $('annRot'); if(!rot) return;
  var lines = rot.querySelectorAll('.ann-line');
  if(lines.length < 2) return;
  var i = 0;
  if(RM || !hasGSAP){
    setInterval(function(){
      lines[i].classList.remove('on');
      i = (i+1) % lines.length;
      lines[i].classList.add('on');
    }, 4200);
    return;
  }
  gsap.set(lines, { yPercent:110, opacity:0 });
  gsap.set(lines[0], { yPercent:0, opacity:1 });
  setInterval(function(){
    var cur = lines[i], nxt = lines[(i+1) % lines.length];
    gsap.to(cur, { yPercent:-110, opacity:0, duration:0.55, ease:'power3.inOut' });
    gsap.fromTo(nxt, { yPercent:110, opacity:0 }, { yPercent:0, opacity:1, duration:0.55, ease:'power3.out', delay:0.08 });
    i = (i+1) % lines.length;
  }, 4200);
})();

/* ---------------- HERO: generative bloom canvas ---------------- */
function bloomField(canvas, opts){
  if(!canvas) return null;
  var ctx = null;
  try{ ctx = canvas.getContext('2d'); }catch(e){ return null; }
  if(!ctx) return null;
  opts = opts || {};
  var DPR = Math.min(window.devicePixelRatio || 1, 2);
  var W = 0, H = 0;
  var segs = [], tips = [], sparks = [], motes = [];
  var maxT = 1, running = false, raf = 0;
  var cycleStart = 0, cycleNum = 1;
  var GROW = 5.6, HOLD = 2.4, FADE = 1.5;
  var pTx = 0.5, pTy = 0.5, pX = 0.5, pY = 0.5;
  var frame = 0;
  var onFrame = opts.onFrame || null;

  function resize(){
    var r = canvas.getBoundingClientRect();
    canvas.width = Math.max(1, Math.round(r.width * DPR));
    canvas.height = Math.max(1, Math.round(r.height * DPR));
    W = canvas.width / DPR;
    H = canvas.height / DPR;
    ctx.setTransform(DPR, 0, 0, DPR, 0, 0);
    build();
  }

  function grow(x, y, ang, len, depth, delay, maxD){
    if(depth > maxD || len < 8){
      tips.push({ x:x, y:y, t:delay, r:1.5 + Math.random()*2.2, ph:Math.random()*6.28 });
      return;
    }
    var x2 = x + Math.cos(ang)*len;
    var y2 = y + Math.sin(ang)*len;
    var t1 = delay + len*0.0092;
    segs.push({ x1:x, y1:y, x2:x2, y2:y2, d:depth, t0:delay, t1:t1 });
    if(t1 > maxT) maxT = t1;
    var kids = depth < 2 ? 2 : (Math.random() < 0.66 ? 2 : 1);
    for(var i=0;i<kids;i++){
      var spread = 0.3 + Math.random()*0.48;
      var sign = kids === 1 ? (Math.random() < 0.5 ? -1 : 1) : (i === 0 ? -1 : 1);
      grow(x2, y2, ang + spread*sign, len*(0.66 + Math.random()*0.14), depth+1, t1, maxD);
    }
  }

  function build(){
    segs = []; tips = []; sparks = []; maxT = 0.001;
    var maxD = W < 760 ? 4 : 5;
    var baseLen = Math.min(W, H) * (W < 760 ? 0.2 : 0.155);
    var roots = W < 760 ? 2 : 3;
    for(var i=0;i<roots;i++){
      var rx = W * (0.2 + (0.6/Math.max(1, roots-1))*i) + (Math.random()-0.5)*W*0.06;
      if(roots === 1) rx = W*0.5;
      var ry = H * (0.98 + Math.random()*0.04);
      grow(rx, ry, -Math.PI/2 + (Math.random()-0.5)*0.44, baseLen, 0, 0, maxD);
    }
    motes = [];
    var mn = W < 760 ? 14 : 26;
    for(var m=0;m<mn;m++){
      motes.push({ x:Math.random()*W, y:Math.random()*H, r:0.8 + Math.random()*2, sp:4 + Math.random()*14, ph:Math.random()*6.28 });
    }
    var sn = W < 760 ? 5 : 9;
    for(var s=0;s<sn;s++) sparks.push({ i:-1, t:0, sp:0.012 + Math.random()*0.02 });
  }

  function mix(a, b, k){ return Math.round(a + (b-a)*k); }

  function render(now, forceFull){
    var elapsed = (now - cycleStart)/1000;
    var alpha = 1;
    if(forceFull){ elapsed = GROW; }
    else {
      if(elapsed > GROW + HOLD + FADE){ cycleStart = now; cycleNum++; build(); elapsed = 0; }
      else if(elapsed > GROW + HOLD){ alpha = Math.max(0, 1 - (elapsed - GROW - HOLD)/FADE); }
    }
    var gp = Math.min(1, elapsed / GROW);
    var segT = gp * maxT;
    var t = now/1000;

    ctx.clearRect(0, 0, W, H);
    ctx.globalAlpha = 1;

    pX += (pTx - pX)*0.06; pY += (pTy - pY)*0.06;
    var ox = (pX - 0.5) * 22, oy = (pY - 0.5) * 12;

    ctx.save();
    ctx.translate(ox, oy);

    /* soft halo */
    var hg = ctx.createRadialGradient(W*0.52, H*0.74, 0, W*0.52, H*0.74, Math.max(W,H)*0.62);
    hg.addColorStop(0, 'rgba(251,207,232,' + (0.3*alpha) + ')');
    hg.addColorStop(0.55, 'rgba(236,72,153,' + (0.07*alpha) + ')');
    hg.addColorStop(1, 'rgba(253,246,250,0)');
    ctx.fillStyle = hg;
    ctx.fillRect(-ox, -oy, W, H);

    /* motes */
    for(var m=0;m<motes.length;m++){
      var mo = motes[m];
      var my = mo.y - ((t*mo.sp) % (H + 80));
      if(my < -40) my += H + 80;
      ctx.beginPath();
      ctx.arc(mo.x + Math.sin(t*0.4 + mo.ph)*8, my, mo.r, 0, 6.2832);
      ctx.fillStyle = 'rgba(154,92,255,' + (0.2*alpha) + ')';
      ctx.fill();
    }

    /* branches */
    var lit = 0;
    for(var i=0;i<segs.length;i++){
      var s = segs[i];
      var span = s.t1 - s.t0;
      var p = span > 0 ? (segT - s.t0)/span : 1;
      if(p <= 0) continue;
      if(p >= 1){ p = 1; lit++; }
      var k = s.d / 5;
      var r = mix(219, 154, k), g = mix(39, 92, k), b = mix(119, 255, k);
      ctx.beginPath();
      ctx.moveTo(s.x1, s.y1);
      ctx.lineTo(s.x1 + (s.x2-s.x1)*p, s.y1 + (s.y2-s.y1)*p);
      ctx.strokeStyle = 'rgba(' + r + ',' + g + ',' + b + ',' + ((0.62 - k*0.22) * alpha) + ')';
      ctx.lineWidth = Math.max(0.7, 3.3 - s.d*0.55);
      ctx.lineCap = 'round';
      ctx.stroke();
    }

    /* tips */
    ctx.shadowColor = 'rgba(236,72,153,' + (0.8*alpha) + ')';
    for(var q=0;q<tips.length;q++){
      var tp = tips[q];
      if(segT < tp.t) continue;
      var pulse = 0.5 + 0.5*Math.sin(t*1.6 + tp.ph);
      ctx.beginPath();
      ctx.arc(tp.x, tp.y, tp.r*(0.8 + pulse*0.5), 0, 6.2832);
      ctx.fillStyle = 'rgba(236,72,153,' + ((0.35 + pulse*0.4) * alpha) + ')';
      ctx.shadowBlur = 8;
      ctx.fill();
    }
    ctx.shadowBlur = 0;

    /* sparks travelling on grown branches */
    if(segs.length){
      for(var sp=0; sp<sparks.length; sp++){
        var sk = sparks[sp];
        if(sk.i < 0 || sk.t >= 1 || !segs[sk.i] || segT < segs[sk.i].t1){
          var tries = 0, pick = -1;
          while(tries++ < 8){
            var c = (Math.random()*segs.length)|0;
            if(segs[c] && segT >= segs[c].t1){ pick = c; break; }
          }
          if(pick < 0){ continue; }
          sk.i = pick; sk.t = 0; sk.sp = 0.012 + Math.random()*0.02;
        }
        var sg = segs[sk.i];
        sk.t += sk.sp;
        var px = sg.x1 + (sg.x2-sg.x1)*Math.min(1, sk.t);
        var py = sg.y1 + (sg.y2-sg.y1)*Math.min(1, sk.t);
        ctx.beginPath();
        ctx.arc(px, py, 2.6, 0, 6.2832);
        ctx.fillStyle = 'rgba(219,39,119,' + (0.9*alpha) + ')';
        ctx.shadowColor = 'rgba(236,72,153,.85)';
        ctx.shadowBlur = 12;
        ctx.fill();
        ctx.shadowBlur = 0;
      }
    }

    ctx.restore();

    frame++;
    if(onFrame && frame % 5 === 0){
      onFrame({ bloom: Math.round(gp*100), paths: lit, cycle: cycleNum });
    }
  }

  function draw(now){
    if(!running) return;
    render(now, false);
    raf = requestAnimationFrame(draw);
  }
  function start(){ if(running) return; running = true; cycleStart = performance.now(); raf = requestAnimationFrame(draw); }
  function stop(){ running = false; if(raf) cancelAnimationFrame(raf); }
  function staticFrame(){
    resize();
    cycleStart = performance.now();
    render(performance.now(), true);
    if(onFrame) onFrame({ bloom:100, paths:segs.length, cycle:1 });
  }
  function pointer(nx, ny){ pTx = nx; pTy = ny; }

  resize();
  window.addEventListener('resize', function(){ resize(); });
  return { start:start, stop:stop, staticFrame:staticFrame, pointer:pointer };
}

/* ---------------- constellation canvas (cta + footer) ---------------- */
function neuralField(canvas, opts){
  if(!canvas) return null;
  var ctx = null;
  try{ ctx = canvas.getContext('2d'); }catch(e){ return null; }
  if(!ctx) return null;
  opts = opts || {};
  var DPR = Math.min(window.devicePixelRatio || 1, 2);
  var W = 0, H = 0, nodes = [], signals = [], running = false, raf = 0, t0 = performance.now();
  var connDist = 0;
  function resize(){
    var r = canvas.getBoundingClientRect();
    canvas.width = Math.max(1, Math.round(r.width * DPR));
    canvas.height = Math.max(1, Math.round(r.height * DPR));
    W = canvas.width / DPR; H = canvas.height / DPR;
    ctx.setTransform(DPR, 0, 0, DPR, 0, 0);
    build();
  }
  function build(){
    var base = opts.count || 14;
    var n = W < 620 ? Math.max(8, Math.round(base*0.6)) : base;
    connDist = Math.min(W, H) * (opts.connect || 0.3);
    nodes = [];
    for(var i=0;i<n;i++){
      nodes.push({ bx:Math.random()*W, by:Math.random()*H, x:0, y:0, r:1.5 + Math.random()*2.3, ph:Math.random()*6.28, amp:8 + Math.random()*20, sp:0.12 + Math.random()*0.3 });
    }
    signals = [];
    var ns = W < 620 ? 3 : (opts.signals || 5);
    for(var k=0;k<ns;k++) signals.push({ a:(Math.random()*n)|0, b:(Math.random()*n)|0, t:Math.random(), sp:0.004 + Math.random()*0.006 });
  }
  function step(now){
    var t = (now - t0)/1000;
    for(var i=0;i<nodes.length;i++){
      var nd = nodes[i];
      nd.x = nd.bx + Math.sin(t*nd.sp + nd.ph)*nd.amp;
      nd.y = nd.by + Math.cos(t*nd.sp*0.85 + nd.ph)*nd.amp;
    }
  }
  function paint(now){
    step(now);
    ctx.clearRect(0, 0, W, H);
    for(var i=0;i<nodes.length;i++){
      for(var j=i+1;j<nodes.length;j++){
        var A = nodes[i], B = nodes[j];
        var dx = A.x-B.x, dy = A.y-B.y, d = Math.sqrt(dx*dx + dy*dy);
        if(d < connDist){
          var a = 1 - d/connDist;
          ctx.beginPath(); ctx.moveTo(A.x, A.y); ctx.lineTo(B.x, B.y);
          ctx.strokeStyle = 'rgba(154,92,255,' + (a*0.48) + ')';
          ctx.lineWidth = 1; ctx.stroke();
        }
      }
    }
    for(var s=0;s<signals.length;s++){
      var sg = signals[s]; sg.t += sg.sp;
      if(sg.t >= 1){ sg.a = sg.b; sg.b = (Math.random()*nodes.length)|0; if(sg.b === sg.a) sg.b = (sg.b+1) % Math.max(1, nodes.length); sg.t = 0; }
      var Na = nodes[sg.a], Nb = nodes[sg.b];
      if(!Na || !Nb) continue;
      ctx.beginPath(); ctx.moveTo(Na.x, Na.y); ctx.lineTo(Nb.x, Nb.y);
      ctx.strokeStyle = 'rgba(244,114,182,.48)'; ctx.lineWidth = 1.4; ctx.stroke();
      ctx.beginPath();
      ctx.arc(Na.x + (Nb.x-Na.x)*sg.t, Na.y + (Nb.y-Na.y)*sg.t, 2.5, 0, 6.2832);
      ctx.fillStyle = 'rgba(253,164,207,.95)';
      ctx.shadowColor = 'rgba(244,114,182,.9)'; ctx.shadowBlur = 10;
      ctx.fill(); ctx.shadowBlur = 0;
    }
    for(var m=0;m<nodes.length;m++){
      var p = nodes[m], pulse = 0.55 + 0.45*Math.sin((now/1000)*1.1 + p.ph);
      var rg = ctx.createRadialGradient(p.x, p.y, 0, p.x, p.y, p.r*6);
      rg.addColorStop(0, 'rgba(244,114,182,' + (0.5*pulse) + ')');
      rg.addColorStop(0.5, 'rgba(154,92,255,' + (0.18*pulse) + ')');
      rg.addColorStop(1, 'rgba(154,92,255,0)');
      ctx.fillStyle = rg;
      ctx.beginPath(); ctx.arc(p.x, p.y, p.r*6, 0, 6.2832); ctx.fill();
      ctx.fillStyle = 'rgba(253,164,207,' + (0.85*pulse) + ')';
      ctx.beginPath(); ctx.arc(p.x, p.y, p.r, 0, 6.2832); ctx.fill();
    }
  }
  function draw(now){ if(!running) return; paint(now); raf = requestAnimationFrame(draw); }
  function start(){ if(running) return; running = true; t0 = performance.now() - 1000; raf = requestAnimationFrame(draw); }
  function stop(){ running = false; if(raf) cancelAnimationFrame(raf); }
  function staticFrame(){ resize(); paint(performance.now()); }
  resize();
  window.addEventListener('resize', function(){ resize(); });
  return { start:start, stop:stop, staticFrame:staticFrame };
}

/* ---------------- star canvas (story band) ---------------- */
function starField(canvas){
  if(!canvas) return null;
  var ctx = null;
  try{ ctx = canvas.getContext('2d'); }catch(e){ return null; }
  if(!ctx) return null;
  var DPR = Math.min(window.devicePixelRatio || 1, 2);
  var W = 0, H = 0, running = false, raf = 0, stars = [];
  function resize(){
    var r = canvas.getBoundingClientRect();
    canvas.width = Math.max(1, Math.round(r.width * DPR));
    canvas.height = Math.max(1, Math.round(r.height * DPR));
    W = canvas.width / DPR; H = canvas.height / DPR;
    ctx.setTransform(DPR, 0, 0, DPR, 0, 0);
    build();
  }
  function build(){
    stars = [];
    var n = W < 620 ? 40 : 84;
    for(var i=0;i<n;i++) stars.push({ x:Math.random()*W, y:Math.random()*H*0.9, r:0.5 + Math.random()*1.5, ph:Math.random()*6.28, sp:0.6 + Math.random()*1.6 });
  }
  function paint(now){
    var t = now/1000;
    ctx.clearRect(0, 0, W, H);
    for(var i=0;i<stars.length;i++){
      var s = stars[i];
      var tw = 0.35 + 0.65*Math.abs(Math.sin(t*s.sp + s.ph));
      ctx.beginPath(); ctx.arc(s.x, s.y, s.r, 0, 6.2832);
      ctx.fillStyle = 'rgba(253,220,238,' + tw + ')';
      ctx.shadowColor = 'rgba(253,164,207,' + (tw*0.6) + ')'; ctx.shadowBlur = 4;
      ctx.fill();
    }
    ctx.shadowBlur = 0;
  }
  function draw(now){ if(!running) return; paint(now); raf = requestAnimationFrame(draw); }
  function start(){ if(running) return; running = true; raf = requestAnimationFrame(draw); }
  function stop(){ running = false; if(raf) cancelAnimationFrame(raf); }
  function staticFrame(){ resize(); paint(performance.now()); }
  resize();
  window.addEventListener('resize', function(){ resize(); });
  return { start:start, stop:stop, staticFrame:staticFrame };
}

/* ---------------- IO gating ---------------- */
function gate(field, el){
  if(!field || !el) return;
  if(RM){ try{ field.staticFrame(); }catch(e){} return; }
  if('IntersectionObserver' in window){
    var io = new IntersectionObserver(function(ents){
      ents.forEach(function(en){ if(en.isIntersecting) field.start(); else field.stop(); });
    }, { threshold:0.02 });
    io.observe(el);
  } else field.start();
}

var hudBloom = $('hudBloom'), hudPaths = $('hudPaths'), hudCycle = $('hudCycle');
function pad2(n){ return (n < 10 ? '0' : '') + n; }
var heroObj = bloomField($('heroCanvas'), {
  onFrame: function(d){
    if(hudBloom) hudBloom.textContent = d.bloom + '%';
    if(hudPaths) hudPaths.textContent = String(d.paths);
    if(hudCycle) hudCycle.textContent = pad2(((d.cycle - 1) % 99) + 1);
  }
});
gate(heroObj, $('hero'));
if(heroObj && !RM && !isMobile){
  var heroEl = $('hero');
  if(heroEl){
    heroEl.addEventListener('mousemove', function(e){
      var r = heroEl.getBoundingClientRect();
      heroObj.pointer((e.clientX - r.left)/Math.max(1, r.width), (e.clientY - r.top)/Math.max(1, r.height));
    }, {passive:true});
  }
}

var ctaObj = neuralField($('ctaCanvas'), { count:14, connect:0.3, signals:5 });
gate(ctaObj, $('start'));
var footObj = neuralField($('footCanvas'), { count:12, connect:0.34, signals:4 });
gate(footObj, document.querySelector('footer'));
var starObj = starField($('storyStars'));
gate(starObj, $('story'));

/* ---------------- tickers and marquees ---------------- */
function fillTicker(el, items, cls){
  if(!el) return;
  var html = '';
  for(var pass=0; pass<3; pass++){
    for(var i=0;i<items.length;i++){ html += '<span' + (cls ? ' class="' + cls + '"' : '') + '>' + items[i] + '</span>'; }
  }
  el.innerHTML = html;
}
function loopMarquee(el, dur){
  if(!el) return;
  if(RM || !hasGSAP) return;
  gsap.to(el, { xPercent:-33.333, duration:dur, ease:'none', repeat:-1 });
}
fillTicker($('heroTicker'), [
  'Secure checkout', 'Clear product information', 'Private support', 'Thoughtful daily wellness',
  'Easy option selection', 'Plain packaging', 'Shop the collection', 'Responsive customer care'
]);
fillTicker($('bandMarq'), ['Desire, understood', 'Shop thoughtfully', 'Clear product details', 'Private delivery']);
fillTicker($('footMarq'), [
  'Read product directions', 'Secure checkout', 'Individual experiences vary',
  'Plain unbranded packaging', 'VESPER wellness shop'
]);
loopMarquee($('heroTicker'), 34);
loopMarquee($('bandMarq'), 26);
loopMarquee($('footMarq'), 40);

/* ---------------- GSAP choreography ---------------- */
if(hasGSAP){
  gsap.defaults({ ease:'power3.out' });

  /* kinetic headings */
  function kinetic(el){
    if(!hasST) { gsap.set(el, { opacity:1 }); return; }
    if(hasSplit){
      try{
        var sp = new SplitText(el, { type:'lines', linesClass:'k-line' });
        sp.lines.forEach(function(ln){
          var w = document.createElement('span');
          w.style.display = 'block';
          w.style.overflow = 'hidden';
          ln.parentNode.insertBefore(w, ln);
          w.appendChild(ln);
        });
        gsap.set(el, { opacity:1 });
        gsap.set(sp.lines, { yPercent:118 });
        gsap.to(sp.lines, { yPercent:0, duration:1, stagger:0.085, ease:'power4.out', scrollTrigger:{ trigger:el, start:'top 88%' } });
        return;
      }catch(e){}
    }
    gsap.fromTo(el, { opacity:0, y:38 }, { opacity:1, y:0, duration:0.9, scrollTrigger:{ trigger:el, start:'top 90%' } });
  }

  function fadeIn(sel, y, stagger){
    gsap.utils.toArray(sel).forEach(function(el){
      gsap.fromTo(el, { opacity:0, y:(y || 28) }, {
        opacity:1, y:0, duration:0.85, ease:'power3.out',
        stagger: stagger || 0,
        scrollTrigger:{ trigger:el, start:'top 92%' }
      });
    });
  }

  function initReveals(){
    if(!hasST || RM) return;
    document.querySelectorAll('.kin').forEach(kinetic);
    fadeIn('[data-fade]', 24);
    fadeIn('[data-pt]', 30);
    fadeIn('[data-rv]', 34);
    fadeIn('[data-tl]', 32);
    fadeIn('[data-sr]', 30);
    ST.refresh();
  }

  if(hasST && !RM){
    if(document.fonts && document.fonts.ready){ document.fonts.ready.then(initReveals); }
    else { initReveals(); }
  } else {
    document.querySelectorAll('.reveal,.kin').forEach(function(el){ el.style.opacity = 1; });
  }

  /* hero intro, fired by the preloader */
  window.__heroIntro = function(){
    if(RM){ document.querySelectorAll('#hero .reveal').forEach(function(el){ el.style.opacity = 1; }); return; }
    var tl = gsap.timeline();
    tl.from('#hero .hero-h1 .l>span', { yPercent:120, duration:1.05, stagger:0.1, ease:'power4.out' }, 0)
      .fromTo('#hero .hero-tagline', { opacity:0, y:16 }, { opacity:1, y:0, duration:0.6 }, 0.12)
      .fromTo('#hero .hero-sub', { opacity:0, y:22 }, { opacity:1, y:0, duration:0.7 }, 0.55)
      .fromTo('#hero .hero-actions', { opacity:0, y:20 }, { opacity:1, y:0, duration:0.65 }, 0.68)
      .fromTo('#hero .hero-note', { opacity:0, y:16 }, { opacity:1, y:0, duration:0.6 }, 0.8)
      .fromTo('#hero .hud', { opacity:0, y:18 }, { opacity:1, y:0, duration:0.55, stagger:0.08 }, 0.88)
      .fromTo('#hero .hero-flag', { opacity:0 }, { opacity:1, duration:0.5 }, 1.05)
      .fromTo('.hero-ticker', { opacity:0 }, { opacity:1, duration:0.6 }, 1.1);
  };

  if(hasST && !RM){

    /* ===== MECHANISM: pinned scrubbed signal ===== */
    (function(){
      var svg = $('mechSvg'); if(!svg) return;
      var base = $('mechBase'), live = $('mechLive'), spark = $('mechSpark');
      var nodes = Array.prototype.slice.call(document.querySelectorAll('#mechSvg .mnode'));
      var numEl = $('mechNum'), fillEl = $('mechFill'), stateEl = $('mechState'), punch = $('mechPunch');
      var verts = [[600,396],[554,324],[694,294],[460,244],[634,204],[784,234],[554,144],[694,114]];
      var cum = [0], total = 0;
      for(var i=1;i<verts.length;i++){
        var dx = verts[i][0]-verts[i-1][0], dy = verts[i][1]-verts[i-1][1];
        total += Math.sqrt(dx*dx + dy*dy);
        cum.push(total);
      }
      var fracs = cum.map(function(c){ return c/total; });
      var len = (base && base.getTotalLength) ? base.getTotalLength() : 0;
      if(len && live){ live.style.strokeDasharray = String(len); live.style.strokeDashoffset = String(len); }

      function apply(p){
        p = Math.max(0, Math.min(1, p));
        if(len && live){
          live.style.strokeDashoffset = String(len*(1-p));
          var pt = base.getPointAtLength(len*p);
          if(pt && spark){ spark.setAttribute('cx', pt.x); spark.setAttribute('cy', pt.y); }
        }
        nodes.forEach(function(nd, i){
          if(p >= fracs[i] - 0.004) nd.classList.add('lit'); else nd.classList.remove('lit');
        });
        var val = Math.round(p*100);
        if(numEl) numEl.innerHTML = val + '<small>%</small>';
        if(fillEl) fillEl.style.width = val + '%';
        if(stateEl){
          stateEl.textContent = p < 0.08 ? 'In the body' : (p < 0.3 ? 'Rising upstream' : (p < 0.75 ? 'Reaching the brain' : 'Desire pathways engaged'));
          if(p >= 0.9) stateEl.classList.add('done'); else stateEl.classList.remove('done');
        }
        if(punch){
          var pp = Math.max(0, (p-0.78)/0.22);
          gsap.set(punch, { opacity:pp, y:(1-pp)*18 });
        }
      }
      apply(0);

      var mm = gsap.matchMedia ? gsap.matchMedia() : null;
      if(mm){
        mm.add('(min-width: 960px)', function(){
          var st = ST.create({
            trigger:'#mechanism', start:'top top', end:'+=170%', pin:'#mechPin',
            scrub:0.6, anticipatePin:1,
            onUpdate:function(self){ apply(self.progress); },
            onRefresh:function(){ apply(0); }
          });
          return function(){ st.kill(true); apply(1); };
        });
        mm.add('(max-width: 959px)', function(){
          var st2 = ST.create({
            trigger:'#mechanism', start:'top 76%', end:'bottom 62%', scrub:0.5,
            onUpdate:function(self){ apply(self.progress); }
          });
          return function(){ st2.kill(true); };
        });
      } else {
        ST.create({ trigger:'#mechanism', start:'top 76%', end:'bottom 62%', scrub:0.5, onUpdate:function(self){ apply(self.progress); } });
      }
    })();

    /* ===== STORY: moon along the arc ===== */
    (function(){
      var arc = $('storyArc'), grp = $('storyMoon');
      if(!arc || !grp || !arc.getTotalLength) return;
      var L = arc.getTotalLength();
      function place(p){
        var pt = arc.getPointAtLength(L*Math.max(0, Math.min(1, p)));
        var p0 = arc.getPointAtLength(0);
        grp.setAttribute('transform', 'translate(' + (pt.x - p0.x) + ',' + (pt.y - p0.y) + ')');
      }
      place(0);
      ST.create({ trigger:'#story', start:'top 76%', end:'bottom 58%', scrub:0.6, onUpdate:function(self){ place(self.progress); } });
    })();

    /* ===== STEPS: spine fill ===== */
    (function(){
      var fill = $('spineFill'); if(!fill) return;
      gsap.fromTo(fill, { scaleY:0 }, {
        scaleY:1, ease:'none',
        scrollTrigger:{ trigger:'.spine', start:'top 72%', end:'bottom 72%', scrub:0.5 }
      });
    })();

    /* ===== STATS counters ===== */
    (function(){
      var row = $('statsRow'); if(!row) return;
      var ks = row.querySelectorAll('.k');
      ST.create({
        trigger: row, start:'top 82%', once:true,
        onEnter:function(){
          ks.forEach(function(k){
            var lit = k.getAttribute('data-literal');
            if(lit){ k.textContent = lit; return; }
            var target = parseFloat(k.getAttribute('data-count') || '0');
            var suffix = k.getAttribute('data-suffix') || '';
            var obj = { v:0 };
            gsap.to(obj, {
              v:target, duration:1.5, ease:'power2.out',
              onUpdate:function(){ k.textContent = Math.round(obj.v) + suffix; }
            });
          });
        }
      });
    })();

    /* ===== product card hover press ===== */
    gsap.utils.toArray('.product-card').forEach(function(card){
      var badge = card.querySelector('.pc-badge');
      if(!badge) return;
      card.addEventListener('mouseenter', function(){ gsap.fromTo(badge, { scale:0.86 }, { scale:1, duration:0.45, ease:'back.out(2.4)' }); });
    });

    /* ===== tile art drift ===== */
    gsap.utils.toArray('.tile').forEach(function(tile){
      var art = tile.querySelector('.tart');
      if(!art) return;
      gsap.fromTo(art, { yPercent:-6 }, {
        yPercent:6, ease:'none',
        scrollTrigger:{ trigger:tile, start:'top bottom', end:'bottom top', scrub:0.8 }
      });
    });
  }
}

/* ---------------- static completion (reduced motion / no ScrollTrigger) ---------------- */
if(RM || !hasST){
  try{
    document.querySelectorAll('#mechSvg .mnode').forEach(function(n){ n.classList.add('lit'); });
    var mBase = $('mechBase'), mLive = $('mechLive'), mSpark = $('mechSpark');
    if(mLive){ mLive.style.strokeDasharray = 'none'; mLive.style.strokeDashoffset = '0'; }
    if(mBase && mBase.getTotalLength && mSpark){
      var mL = mBase.getTotalLength(), mPt = mBase.getPointAtLength(mL);
      mSpark.setAttribute('cx', mPt.x); mSpark.setAttribute('cy', mPt.y);
    }
    var mNum = $('mechNum'), mFill = $('mechFill'), mState = $('mechState'), mPunch = $('mechPunch');
    if(mNum) mNum.innerHTML = '100<small>%</small>';
    if(mFill) mFill.style.width = '100%';
    if(mState){ mState.textContent = 'Desire pathways engaged'; mState.classList.add('done'); }
    if(mPunch) mPunch.style.opacity = '1';
    var sArc = $('storyArc'), sMoon = $('storyMoon');
    if(sArc && sMoon && sArc.getTotalLength){
      var aL = sArc.getTotalLength(), aPt = sArc.getPointAtLength(aL*0.5), a0 = sArc.getPointAtLength(0);
      sMoon.setAttribute('transform', 'translate(' + (aPt.x - a0.x) + ',' + (aPt.y - a0.y) + ')');
    }
    var sFill = $('spineFill'); if(sFill) sFill.style.transform = 'scaleY(1)';
    var sRow = $('statsRow');
    if(sRow){
      sRow.querySelectorAll('.k').forEach(function(k){
        var lit = k.getAttribute('data-literal');
        k.textContent = lit ? lit : ((k.getAttribute('data-count') || '0') + (k.getAttribute('data-suffix') || ''));
      });
    }
  }catch(e){}
}

/* ---------------- filter chips ---------------- */
(function(){
  var wrap = $('filterChips'), grid = $('optionGrid');
  if(!wrap || !grid) return;
  var chips = wrap.querySelectorAll('.chip');
  var cards = Array.prototype.slice.call(grid.querySelectorAll('.product-card'));
  chips.forEach(function(chip){
    chip.addEventListener('click', function(){
      chips.forEach(function(c){ c.classList.remove('on'); });
      chip.classList.add('on');
      var f = chip.getAttribute('data-filter');
      var shown = [];
      cards.forEach(function(card){
        var match = (f === 'all') || card.getAttribute('data-cat') === f;
        if(match){ card.style.display = ''; shown.push(card); }
        else { card.style.display = 'none'; }
      });
      if(hasGSAP && !RM && shown.length){
        gsap.fromTo(shown, { opacity:0, y:22, scale:0.975 }, {
          opacity:1, y:0, scale:1, duration:0.52, ease:'power3.out', stagger:0.05, overwrite:true
        });
      } else {
        shown.forEach(function(c){ c.style.opacity = 1; });
      }
      if(hasST) ST.refresh();
    });
  });
})();

/* ---------------- FAQ accordion ---------------- */
(function(){
  var items = document.querySelectorAll('.faq-item');
  items.forEach(function(it){
    var q = it.querySelector('.faq-q'), a = it.querySelector('.faq-a'), inner = it.querySelector('.faq-a-inner');
    if(!q || !a || !inner) return;
    q.setAttribute('aria-expanded', 'false');
    q.addEventListener('click', function(){
      var open = it.classList.contains('open');
      items.forEach(function(o){
        if(o !== it){
          o.classList.remove('open');
          var ob = o.querySelector('.faq-q'); if(ob) ob.setAttribute('aria-expanded', 'false');
          var oa = o.querySelector('.faq-a');
          if(oa){ if(hasGSAP) gsap.to(oa, { height:0, duration:0.4, ease:'power3.inOut' }); else oa.style.height = '0px'; }
        }
      });
      if(open){
        it.classList.remove('open');
        q.setAttribute('aria-expanded', 'false');
        if(hasGSAP) gsap.to(a, { height:0, duration:0.4, ease:'power3.inOut' }); else a.style.height = '0px';
      } else {
        it.classList.add('open');
        q.setAttribute('aria-expanded', 'true');
        var h = inner.offsetHeight;
        if(hasGSAP) gsap.fromTo(a, { height:0 }, { height:h, duration:0.5, ease:'power3.out' }); else a.style.height = h + 'px';
      }
      if(hasST) setTimeout(function(){ ST.refresh(); }, 520);
    });
  });
})();

/* ---------------- magnetic buttons ---------------- */
(function(){
  if(RM || isMobile) return;
  document.querySelectorAll('[data-magnetic]').forEach(function(btn){
    var strength = 0.28;
    btn.addEventListener('mousemove', function(e){
      var r = btn.getBoundingClientRect();
      var mx = e.clientX - r.left - r.width/2;
      var my = e.clientY - r.top - r.height/2;
      if(hasGSAP) gsap.to(btn, { x:mx*strength, y:my*strength, duration:0.5, ease:'power3.out' });
      else btn.style.transform = 'translate(' + (mx*strength) + 'px,' + (my*strength) + 'px)';
    });
    btn.addEventListener('mouseleave', function(){
      if(hasGSAP) gsap.to(btn, { x:0, y:0, duration:0.6, ease:'elastic.out(1,0.4)' });
      else btn.style.transform = '';
    });
  });
})();

/* ---------------- newsletter mock ---------------- */
(function(){
  var btn = $('newsBtn'), field = $('newsEmail'), note = $('newsMock');
  if(!btn || !note) return;
  btn.addEventListener('click', function(){
    note.textContent = 'Demo only, nothing was submitted';
    if(hasGSAP && !RM) gsap.fromTo(note, { opacity:0, y:6 }, { opacity:1, y:0, duration:0.4 });
    if(field) field.value = '';
  });
})();

/* ---------------- burger ---------------- */
(function(){
  var b = $('burger');
  if(b) b.addEventListener('click', function(){ scrollToId('#treatments'); });
})();

/* ---------------- easter egg: logo click blooms a spark ---------------- */
(function(){
  var logo = $('brandLogo'); if(!logo) return;
  logo.addEventListener('click', function(e){
    if(RM) return;
    for(var i=0;i<18;i++){
      var s = document.createElement('div');
      s.style.cssText = 'position:fixed;left:' + e.clientX + 'px;top:' + e.clientY + 'px;width:6px;height:6px;border-radius:50%;pointer-events:none;z-index:9700;background:' + (i % 2 ? '#EC4899' : '#9A5CFF') + ';box-shadow:0 0 10px #EC4899';
      document.body.appendChild(s);
      var ang = Math.random()*6.28, dist = 55 + Math.random()*115;
      if(hasGSAP){
        gsap.to(s, {
          x:Math.cos(ang)*dist, y:Math.sin(ang)*dist, opacity:0, scale:0.2,
          duration:0.7 + Math.random()*0.5, ease:'power3.out',
          onComplete:function(){ var tg = this.targets()[0]; if(tg && tg.parentNode) tg.parentNode.removeChild(tg); }
        });
      } else {
        setTimeout((function(el){ return function(){ if(el.parentNode) el.parentNode.removeChild(el); }; })(s), 700);
      }
    }
  });
})();

/* ---------------- preloader ---------------- */
(function(){
  var pre = $('pre'), count = $('preCount'), branch = $('preBranch');
  function finish(){
    if(pre){
      if(hasGSAP){ gsap.to(pre, { opacity:0, duration:0.55, ease:'power2.inOut', onComplete:function(){ pre.style.display = 'none'; } }); }
      else { pre.style.display = 'none'; }
    }
    if(hasGSAP && window.__heroIntro){ window.__heroIntro(); }
    else { document.querySelectorAll('#hero .reveal').forEach(function(el){ el.style.opacity = 1; }); }
    if(hasST) setTimeout(function(){ ST.refresh(); }, 260);
  }
  if(RM){
    if(pre) pre.style.display = 'none';
    document.querySelectorAll('.reveal,.kin').forEach(function(el){ el.style.opacity = 1; });
    if(hasST) ST.refresh();
    return;
  }
  var t0 = performance.now(), dur = 1400;
  var blen = (branch && branch.getTotalLength) ? branch.getTotalLength() : 0;
  if(branch && blen){ branch.style.strokeDasharray = String(blen); branch.style.strokeDashoffset = String(blen); }
  function tick(now){
    var p = Math.min(1, (now - t0)/dur);
    var e = 1 - Math.pow(1-p, 3);
    if(count) count.textContent = String(Math.round(e*100));
    if(branch && blen) branch.style.strokeDashoffset = String(blen*(1-e));
    if(p < 1) requestAnimationFrame(tick); else setTimeout(finish, 180);
  }
  requestAnimationFrame(tick);
  setTimeout(function(){ if(pre && pre.style.display !== 'none'){ finish(); } }, 2500);
})();

/* ---------------- refresh after load ---------------- */
window.addEventListener('load', function(){ if(hasST) setTimeout(function(){ ST.refresh(); }, 320); });

})();


/* Shopify storefront additions */
(function(){
  function updateCartCount(count){document.querySelectorAll('[data-cart-count]').forEach(function(el){el.textContent=String(count);});}
  document.addEventListener('submit',function(e){
    var form=e.target.closest('[data-ajax-product-form]'); if(!form) return;
    e.preventDefault();
    var card=form.closest('.product-card'); var btn=form.querySelector('button[type="submit"]'); var label=btn&&btn.querySelector('[data-add-text]');
    if(card) card.classList.add('is-adding'); if(btn) btn.disabled=true; if(label) label.textContent='Adding…';
    fetch((window.Shopify&&Shopify.routes&&Shopify.routes.root?Shopify.routes.root:'/')+'cart/add.js',{method:'POST',headers:{'Accept':'application/json'},body:new FormData(form)})
      .then(function(r){if(!r.ok) return r.json().then(function(j){throw new Error(j.description||'Unable to add item');});return r.json();})
      .then(function(){return fetch((window.Shopify&&Shopify.routes&&Shopify.routes.root?Shopify.routes.root:'/')+'cart.js',{headers:{'Accept':'application/json'}});})
      .then(function(r){return r.json();}).then(function(cart){updateCartCount(cart.item_count);if(card){card.classList.remove('is-adding');card.classList.add('is-added');}if(label) label.textContent='Added to cart';setTimeout(function(){if(label) label.textContent='Add to cart';if(card)card.classList.remove('is-added');if(btn)btn.disabled=false;},1500);})
      .catch(function(err){if(card)card.classList.remove('is-adding');if(label)label.textContent=err.message||'Try again';setTimeout(function(){if(label)label.textContent='Add to cart';if(btn)btn.disabled=false;},2200);});
  });
  function initHeader(root){root=root||document;var toggle=root.querySelector('[data-mobile-menu-toggle]');var menu=document.querySelector('[data-mobile-menu]');if(!toggle||!menu||toggle.dataset.ready)return;toggle.dataset.ready='1';toggle.addEventListener('click',function(){var open=toggle.getAttribute('aria-expanded')==='true';toggle.setAttribute('aria-expanded',String(!open));menu.hidden=open;});menu.querySelectorAll('a').forEach(function(a){a.addEventListener('click',function(){menu.hidden=true;toggle.setAttribute('aria-expanded','false');});});}
  document.addEventListener('DOMContentLoaded',function(){initHeader(document);});
  document.addEventListener('shopify:section:load',function(e){initHeader(e.target);if(window.ScrollTrigger)setTimeout(function(){ScrollTrigger.refresh();},80);});
})();

/* Adaptive product-card badge color — sampled from the product image, hue-matched */
(function(){
  function toHsl(r,g,b){r/=255;g/=255;b/=255;var mx=Math.max(r,g,b),mn=Math.min(r,g,b),l=(mx+mn)/2,h=0,s=0;if(mx!==mn){var dd=mx-mn;s=l>0.5?dd/(2-mx-mn):dd/(mx+mn);if(mx===r)h=(g-b)/dd+(g<b?6:0);else if(mx===g)h=(b-r)/dd+2;else h=(r-g)/dd+4;h/=6;}return[h,s,l];}
  function toRgb(h,s,l){function q(p,q,t){if(t<0)t+=1;if(t>1)t-=1;if(t<1/6)return p+(q-p)*6*t;if(t<1/2)return q;if(t<2/3)return p+(q-p)*(2/3-t)*6;return p;}var r,g,b;if(s===0){r=g=b=l;}else{var Q=l<0.5?l*(1+s):l+s-l*s,P=2*l-Q;r=q(P,Q,h+1/3);g=q(P,Q,h);b=q(P,Q,h-1/3);}return[Math.round(r*255),Math.round(g*255),Math.round(b*255)];}
  function clamp(v,a,b){return Math.min(b,Math.max(a,v));}
  function sample(img){
    try{
      var c=document.createElement('canvas'),w=c.width=40,h=c.height=40,ctx=c.getContext('2d');
      ctx.drawImage(img,0,0,w,h);
      var d=ctx.getImageData(0,0,w,h).data,r=0,g=0,b=0,n=0;
      for(var i=0;i<d.length;i+=4){var R=d[i],G=d[i+1],B=d[i+2];if(d[i+3]<130)continue;var t=toHsl(R,G,B);if(t[1]<0.22||t[2]<0.18||t[2]>0.85)continue;r+=R;g+=G;b+=B;n++;}
      if(n<15)return null;return[r/n,g/n,b/n];
    }catch(e){return null;}
  }
  function paint(card){
    var badge=card.querySelector('.pc-badge'),src=card.querySelector('.pc-product-image');
    if(!badge||!src||badge.dataset.adapted)return;
    var url=src.currentSrc||src.getAttribute('src');if(!url)return;
    var im=new Image();im.crossOrigin='anonymous';
    im.onload=function(){
      var avg=sample(im);if(!avg)return;
      var hsl=toHsl(avg[0],avg[1],avg[2]);
      var H=hsl[0], S=clamp(hsl[1]*1.5,0.55,0.95), L=clamp(hsl[2],0.44,0.6);
      var main=toRgb(H,S,L), deep=toRgb(H,clamp(S+0.05,0,1),clamp(L-0.16,0.2,1));
      var Lm=(0.2126*main[0]+0.7152*main[1]+0.0722*main[2])/255;
      badge.style.background='linear-gradient(120deg,rgb('+main.join(',')+'),rgb('+deep.join(',')+'))';
      badge.style.color=Lm>0.62?'#2a1c00':'#fff';
      badge.style.boxShadow='0 6px 18px rgba('+main.join(',')+',0.34)';
      badge.dataset.adapted='1';
    };
    im.src=url;
  }
  function run(root){var cards=(root||document).querySelectorAll('.product-card');for(var i=0;i<cards.length;i++)paint(cards[i]);}
  if(document.readyState!=='loading')run();else document.addEventListener('DOMContentLoaded',function(){run();});
  document.addEventListener('shopify:section:load',function(e){run(e.target);});
})();
